export default {
  items: [
    {
      name: 'Inicio',
      url: '/cme/inicio',
      icon: 'icon-home'
    },
    {
      name: 'Perfil',
      url: '/cme/perfil',
      icon: 'icon-user'
    },
    {
      name: 'Guías Educativas',
      url: '/cme/guias',
      icon: 'icon-graduation'
    },
    {
      name: 'Mis Cursos',
      url:'/cme/cursos',
      icon: 'icon-puzzle',
      children: []
    },
    {
      name: 'Recursos',
      url:'/cme/material',
      icon: 'icon-pencil',
      children: [
        {
          name: 'Recursos en Línea',
          url: '/cme/material/recursos/o',
          icon: 'icon-globe'
        },
        {
          name: 'Mis Recursos',
          url: '/cme/material/recursos/l',
          icon: 'icon-heart'
        },
        {
          name: 'Constructor',
          url: '/cme/material/nuevo',
          icon: 'icon-plus'
        }
      ]
    },
    {
      name: 'Papelera',
      url: '/cme/papelera',
      icon: 'icon-trash'
    }

  ]
}
